<template>
  <div class="cap_leftbar p_right" :class="showNav ? 'active' : ' '">
    <!-- <div class="cap_leftbar p_right open-left-menu"> -->
    <div class="cap_logo">
      <router-link class="closeMob" to="/home"
        ><img
          src="../../../../static/website/images/white-logo.svg"
          alt="Captail wallet"
      /></router-link>
      <div class="resPOnsive-menu navbar-light">
        <div class="px-3 customMobMenu onltMOb">
          <div class="d-flex align-items-center justify-content-end mobDir">
            <nav
              class="cap_profile navbar"
              :class="
                $route.path == '/complete-steps'
                  ? 'd-flex align-items-center'
                  : ''
              "
            >
              <div class="notification">
                <ul class="nav customNotify">
                  <li class="nav-item dropdown">
                    <a
                      class="nav-link p-0"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      v-on:click="refreshNotificaion()"
                    >
                      <feather type="bell"></feather>
                      <span
                        class="number"
                        v-if="notificationList.totalRecords"
                        >{{ notificationList.totalRecords }}</span
                      >
                    </a>
                    <ul class="dropdown-menu">
                      <li class="head">
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <span
                            >Notifications ({{
                              notificationList.totalRecords || 0
                            }})</span
                          >
                          <router-link to="/notification" class="textLink"
                            >View all</router-link
                          >
                        </div>
                      </li>
                      <li
                        class="notification-box"
                        v-for="list in notificationList.records"
                      >
                        <feather type="user" class="rounded-circle"></feather>
                        <div class="dueName" v-html="list.msg"></div>
                      </li>
                      <li
                        class="notification-box noneNotify"
                        v-if="
                          !(
                            notificationList.totalRecords &&
                            notificationList.totalRecords != 0
                          )
                        "
                      >
                        <div class="imgNorIcon">
                          <img
                            src="../../../../static/website/images/4707150.svg"
                            alt="Icon"
                          />
                          <h5>No message notification</h5>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <ul class="nav-menu leftDrop-down border-left pl-3">
            <li class="nav-item dropdown">
              <a
                href="#"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                class="nav-link onlyweb-show"
              >
                <span
                  v-if="
                    get_user.profile.firstname != '' &&
                    get_user.profile.firstname != null
                  "
                  >{{ get_user.profile.firstname
                  }}{{ get_user.lastname ? get_user.lastname : "" }}</span
                >
                <span v-else>{{ get_user.email }}</span>
                <feather class="icon" type="chevron-down"></feather>
              </a>
              <a
                href="#"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                class="nav-link onlyMoble-show"
              >
                <span
                  v-if="
                    get_user.profile.firstname != '' &&
                    get_user.profile.firstname != null
                  "
                  >{{ get_user.profile.firstname.charAt(0)
                  }}{{
                    get_user.lastname ? get_user.lastname.charAt(0) : ""
                  }}</span
                >
                <span v-else>{{ get_user.email.charAt(0) }}</span>
                <feather class="icon" type="chevron-down"></feather>
              </a>
            <div class="dropdown-menu newMegaDropDown box-shadow">
                <div class="userName">
                    <p class="fLetter">A</p>
                    <h5>{{ get_user.username }}</h5>
                    <p>{{ get_user.email }}</p>
                </div>
                <ul aria-labelledby="languages">
                  <li>
                    <router-link to="/settings" class="dropdown-item"
                      >Settings</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/help-centre" class="dropdown-item"
                      >Help & Support</router-link
                    >
                  </li>
                  <!-- <li><a href="javascript:void(0)" class="dropdown-item">About US</a></li> -->
                  <li v-if="parseInt(get_user.tier) == 1">
                    <router-link
                      :to="'/individual-step' + (parseInt(get_user.step) + 1)"
                      class="dropdown-item"
                      v-if="
                        parseInt(get_user.lead_type) == 0 &&
                        parseInt(get_user.step) < 3
                      "
                    >
                      Upgrade to higher limits
                    </router-link>
                    <router-link
                      :to="'/corporate-step' + (parseInt(get_user.step) + 1)"
                      class="dropdown-item"
                      v-if="
                        parseInt(get_user.lead_type) == 1 &&
                        parseInt(get_user.step) < 4
                      "
                    >
                      Upgrade to higher limits
                    </router-link>
                  </li>
                  <!-- <li v-else-if="parseInt(get_user.tier)==2"> <a href="#" @click.prevent.stop="" class="dropdown-item disabled" title="Your Account is under verification">Upgrade to higher limits</a> </li>-->
                  <li v-else-if="parseInt(get_user.tier) == 3">
                    <router-link
                      :to="{
                        name: 'help_centre',
                        params: {
                          page: 'profile',
                          ticketData: '16',
                          method_id: '1',
                        },
                      }"
                      @click.prevent=""
                      class="dropdown-item"
                    >
                      Upgrade to withdraw fiat
                    </router-link>
                  </li>
                  <!-- <li v-else-if="parseInt(get_user.tier)==4"> <a href="#" @click.prevent.stop="" class="dropdown-item disabled" title="Your bank account verification is under precess">Upgrade to higher limits</a> </li>-->
                  <!-- <li :class="$route.name=='payment-methods' ? 'active' : ''"><router-link class="dropdown-item" to="/payment-methods">Payment Methods</router-link></li> -->
                  <!-- <li :class="$route.name=='ip-whiteList' ? 'active' : ''"><router-link class="dropdown-item" to="/ip-whiteList">IP Whitelist </router-link></li> -->
                  <li
                    :class="$route.name == 'api_access' ? 'active' : ''"
                    v-if="
                      parseInt(get_user.lead_type) == 1 &&
                      parseInt(get_user.verified_status) == 1
                    "
                  >
                    <router-link class="dropdown-item" to="/developer-option"
                      >Developer Option
                    </router-link>
                  </li>
                  <!-- <li><router-link to="/change-password" class="dropdown-item">Reset Password</router-link></li> -->
                  <li @click="logout()">
                    <a href="#" class="dropdown-item red">Sign Out</a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
            </nav>
          </div>
        </div>

        <div class="d-flex align-items-center">
          <!-- <div class="mr-2 mobTrade">
                        <a :href="'https://dev.finvasia.com:8095?token='+token" target="_blank" class="cap_btn d-flex align-items-center"><feather size="16px" type="trending-up" class="mr-2"></feather> Web Trader</a>
                    </div> -->
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click.prevent.stop="showNav = !showNav"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
      </div>
    </div>

    <div
      class="left_scrollbar right_scrollbar justify-content-between"
      :class="showNav ? 'show' : ''"
    >
      <div class="flex-column d-flex justify-content-between leftCal-height">
        <div class="dir-effect">
          <nav class="side-navbar main-menu">
            <ul id="side-main-menu" class="side-menu list-unstyled">
              <li :class="$route.name == 'home' ? 'active' : ''">
                <router-link class="closeMob" to="/"
                  ><span class="sprite1"></span> Dashboard
                </router-link>
              </li>
              <!-- <li :class="$route.name == 'markets' ? 'active' : ''">
                <router-link class="closeMob" to="/markets"
                  ><span class="sprite2"></span> Markets</router-link
                >
              </li> -->
              <li :class="$route.name == 'smart_trading' ? 'active' : ''" v-if="permissionModule('CONVERSION')">
                <router-link class="closeMob" to="/smart-trading"
                  ><span class="sprite3"></span> Instant Conversion
                </router-link>
              </li>
              <!-- <li :class="$route.name == 'social_trading' ? 'active' : ''">
                <router-link class="closeMob" to="/social-trading"
                  ><span class="sprite9"></span> Social Trading
                  <sup>BETA</sup></router-link
                >
              </li> -->
              <!-- <li :class="$route.name == 'portfolio' ? 'active' : ''">
                <router-link class="closeMob" to="/portfolio"
                  ><span class="sprite4"></span> Portfolio
                </router-link>
              </li> -->
              <li :class="$route.name == 'deposit_withdrawal' ? 'active' : ''">
                <router-link class="closeMob" to="/deposit-withdrawal"
                  ><span class="sprite5"></span> Deposit/Withdrawal
                </router-link>
              </li>
              <li :class="$route.name == 'wallets' ? 'active' : ''">
                <router-link class="closeMob" to="/wallets"
                  ><span class="sprite6"></span> Wallet</router-link
                >
              </li>
              <li :class="$route.name == 'transaction-history' ? 'active' : ''">
                <router-link class="closeMob" to="/transaction-history"
                  ><span class="sprite7"></span> Transaction History</router-link
                >
              </li>
              <li :class="$route.name == 'help_centre' ? 'active' : ''">
                <router-link class="closeMob" to="/help-centre"
                  ><span class="sprite8"></span> Support</router-link
                >
              </li>
              <!-- <li :class="($route.name == 'trading')?'active':''"><router-link class="closeMob" to="/trading"><span class="sprite3"></span> Trading</router-link></li> -->
              <!-- <li :class="($route.name == 'deposit-withdraw')?'active':''"><router-link class="closeMob" to="/deposit-withdraw"><span class="sprite10"></span> Deposit/Withdraw</router-link></li> -->
              <!-- <li :class="($route.name == 'deposit-withdrawal')?'active':''"><router-link class="closeMob" to="/deposit-withdrawal"><span class="sprite6"></span> Deposit & Withdrawal</router-link></li> -->
              <!-- <li :class="($route.name == 'order-history')?'active':''"><router-link class="closeMob" to="/order-history"><span class="sprite7"></span> Order History</router-link></li> -->
              <li
                class="d-none mob-block"
                v-if="[1, 3].includes(parseInt(get_user.tier))"
                :class="$route.name == 'upgrade' ? 'active' : ''"
              >
                <a
                  @click.prevent="withdrawLimit()"
                  class="upgradeLimit"
                  href="#"
                >
                  <span class="sprite8"></span> Upgrade to
                  {{
                    parseInt(get_user.tier) <= 2
                      ? "higher limits"
                      : "withdraw fiat"
                  }}</a
                >
              </li>
              <!-- <li><a href="#exampledropdownDropdown" aria-expanded="false" data-toggle="collapse"><span class="sprite8"></span> Settings</a>
                                <ul id="exampledropdownDropdown" class="collapse list-unstyled ">
                                    <li :class="($route.name == 'account-setting')?'active':''"><router-link to="/account-setting">Account Setting</router-link></li>
                                    <li :class="($route.name == 'ip-wishlist-address')?'active':''"><router-link to="/ip-wishlist-address">IP Wishlist Address</router-link></li>
                                    <li :class="($route.name == 'wallet-address')?'active':''"><router-link to="/wallet-address">Wallet Address</router-link></li>
                                    <li :class="($route.name == 'payment-methods')?'active':''"><router-link to="/payment-methods">Payment Methods</router-link></li>
                                </ul>
                            </li> -->
            </ul>
          </nav>
        </div>

        <div class="formCode-submit leftNav-bottom">
          <a href="#" class="border-btn" :class="{'redBG' : parseInt(get_user.tier) <= 2 , 'yellowBG' : parseInt(get_user.tier) > 2 }" @click.prevent="withdrawLimit()" v-if="[1, 3].includes(parseInt(get_user.tier))">
            Increase Account
            {{parseInt(get_user.tier) <= 2 ? "Limits" : "withdraw fiat"}}
          </a>
          <ul class="socialIcon d-flex align-items-center justify-content-center mt-4">
            <li>
              <a :href="$env_var.fbLink" target="_blank"><feather type="facebook"></feather></a>
            </li>
            <li>
              <a :href="$env_var.twitterLink" target="_blank"><feather type="twitter"></feather></a>
            </li>
            <li>
              <a :href="$env_var.instaLink" target="_blank"><feather type="instagram"></feather></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tradingMixins from "@/plugins/trading";
import * as types from "@/types";
import { mapActions } from "vuex";
export default {
  name: "left-nav",
  mixins: [tradingMixins],
  data() {
    return {
      showNav: false,
    };
  },
  methods: {
    /*get_user_func(){
            console.log('this.get_user-----',this.get_user)
            if(parseInt(this.get_user.lead_type) == 0 && parseInt(this.get_user.step) < 3){
                 console.log('----------------in-1----------')
                return true ;
            }else if(parseInt(this.get_user.lead_type) == 1 && parseInt(this.get_user.step) < 4){
                 console.log('----------------in-2----------')
                return false ;
            }else{
                console.log('----------------in--3---------')
                return true ;
            }
        }*/
    ...mapActions({
      _runLogout: types.RUN_LOGOUT,
    }),
    logout() {
      if (this.pageLoader) {
        return;
      }
      let input_json = {
        globalParams: {},
        localParams: { parameter: this },
      };
      this._runLogout(input_json);
    },
    refreshNotificaion() {
      this._runGetNotificationList({
        globalParams: {},
        localParams: { parameter: this },
      });
    },

    orderlisting() {
      if (this.tradingAccount.length > 0) {
        let jsonData = {
          globalParams: {
            account_id: this.tradingAccount[0].account_id,
            demo_live: this.tradingAccount[0].demo_live,
          },
          localParams: { parameter: this, page: "home" },
        };
        this._runGetOrderList(jsonData);
      }
    },
  },
  created() {
    this.orderlisting();
  },
  mounted() {
    if ($(window).width() <= 1600) {
      $(".right_scrollbar").overlayScrollbars({});
    }

    $(".mid_scroll_content, .wallet_cur").overlayScrollbars({});

    $(document).ready(function () {
      $("g[aria-labelledby]").hide();
    });
    const _that = this;
    jQuery(document).ready(function ($) {
      var alterClass = function () {
        var ww = document.body.clientWidth;
        if (ww > 1200) {
          _that.showNav = false;
        }
      };
      $(window).resize(function () {
        alterClass();
      });
      alterClass();
      $(".closeMob").on("click", function (event) {
        _that.showNav = false;
      });
    });
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/website/shared/left-nav.vue